var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWidgetStep = function SvgWidgetStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.968,
    d: "M40.471 29.501v3.93l-5.139-2.967v5.899l-3.425-1.98v-5.898l-5.134-2.966V21.59l5.134 2.966v-5.898l.338.193 3.087 1.786v5.898z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.968,
    d: "M40.471 43.258v15.726L9.644 41.182V5.806l9.677 5.584 3.426 1.974.6.349v3.934l-.6-.349-3.426-1.974-6.252-3.61v27.513l23.976 13.844V41.279z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.968,
    d: "M45.01 31.161v.363l-9.678 4.839v-5.899l5.14 2.967 4.2-2.1zM45.01 15.8l-3.425 1.712-2.047 1.026-3.087 1.544-1.118.556-3.087-1.785-.339-.194 9.677-4.839z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.968,
    d: "M45.01 15.798v5.899l-3.644 1.824-6.034 3.014v-5.898l1.118-.556 3.087-1.544 2.047-1.026z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.968,
    d: "M50.149 24.663 46.5 26.488l-1.49.745-3.426 1.713-1.113.556-5.139-2.966 6.034-3.015 3.644-1.824zM50.149 38.42l-3.426 1.713-6.252 3.126-3.425-1.98 9.677-4.838zM33.025 8.874v3.934l-9.678 4.839v-3.934l6.025-3.015z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.968,
    d: "m33.025 8.874-3.654 1.824-6.024 3.015-.6-.348-3.426-1.975-9.677-5.584L19.32.968zM50.149 24.664v3.929l-5.139 2.569-.339.17-4.2 2.1v-3.93l1.113-.556 3.426-1.713 1.49-.745zM31.907 19.025v5.531l-5.134-2.966zM37.046 42.643V53.07L13.07 39.226l6.251-3.125 3.426-1.713z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.968,
    d: "M22.747 17.298v17.09l-3.426 1.714-6.251 3.125V11.714l6.251 3.61zM50.149 38.419v15.726l-9.678 4.838V43.259l6.252-3.126z"
  })));
};
export default SvgWidgetStep;